var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRegister = function SvgIconRegister(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.501 7.5a2 2 0 0 1 2-2h9a.5.5 0 0 1 0 1h-9a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a.5.5 0 1 1 1 0v8a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.772 4a.95.95 0 0 0-.67.276L11.15 11.17a.95.95 0 0 0-.278.621l-.365 2.178a1 1 0 0 0-.007.083.945.945 0 0 0 1.053.936l2.107-.438a.95.95 0 0 0 .61-.274l6.95-6.897a.946.946 0 0 0 0-1.342l-1.778-1.762a.95.95 0 0 0-.67-.276m1.706 2.71-1.706-1.691-1.277 1.268 1.698 1.697zm-1.995 1.979L16.785 6.99l-4.914 4.874q-.001.03-.007.06l-.343 2.05 1.977-.412a1 1 0 0 1 .082-.01z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.001 16a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
  })));
};
export default SvgIconRegister;